import { render } from "./ObjectCopy.vue?vue&type=template&id=7e984626"
import script from "./ObjectCopy.vue?vue&type=script&lang=js"
export * from "./ObjectCopy.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__